import { PaperPlaneSkyblue } from "components/icons/PaperPlaneSkyblue";
import { RocketPurpleAnimate } from "components/icons/RocketPurpleAnimate";
import { PlanCard } from "components/SubscriptionModal/PlanCard";
import { OPEN_CHECKOUT } from "constants/analyticsEvents";
import { BOOKS_PLUS_PLAN } from "constants/subscriptionType";
import { useAnalytics } from "hooks/useAnalytics";
import { useModal } from "hooks/useModal";
import { Subscription } from "types/Models/subscription";

type BooksSubscriptionContentProps = {
  softwareStandardActivePlan?: Subscription;
  price?: number;
  selectedPlan?: Subscription;
  billingCycle?: string;
  buttonType?: "primary-outlined" | "secondary";
  buttonText?: string;
  onManage?: (subscription: Subscription) => void;
  subscriptionPlans?: Subscription[];
  setSelectedPlan?: (plan: Subscription) => void;
  checkoutModal?: ReturnType<typeof useModal>;
  hideUpgrade?: boolean;
  containsRadio?: boolean;
  isRadioChecked?: boolean;
  isRadioDisabled?: boolean;
  onRadioChange?: (value: string) => void;
  radioValue?: string;
  onPlanOptionSelect?: (option: Subscription) => void;
  toggleValue?: string;
  isFreePlanActive?: boolean;
  disableFreeplan?: boolean;
};

export const BooksSubscriptionContent = ({
  softwareStandardActivePlan,
  price,
  selectedPlan,
  billingCycle,
  buttonType,
  buttonText,
  onManage,
  subscriptionPlans,
  setSelectedPlan,
  checkoutModal,
  hideUpgrade,
  containsRadio,
  isRadioDisabled,
  onRadioChange,
  radioValue,
  onPlanOptionSelect,
  toggleValue,
  isFreePlanActive,
  disableFreeplan,
}: BooksSubscriptionContentProps) => {
  const { trackEvent } = useAnalytics();

  const handleOnUpgrade = () => {
    softwareStandardActivePlan
      ? onManage?.(softwareStandardActivePlan)
      : checkoutModal?.open();
    trackEvent(OPEN_CHECKOUT, {
      plan: selectedPlan?.billing_cycle || "monthly",
      from: "side_nav_upgrade_click",
    });
  };
  const freePlanFeatures = [
    {
      description: "Up to 2 data connections",
      active: true,
    },
    {
      description: "Cash & Accrual financials",
      active: true,
    },
    {
      description: "Stripe direct connect",
      active: false,
    },
    {
      description: "Automated categorization",
      active: false,
    },
    {
      description: "Access to monthly bookkeeper",
      active: false,
    },
  ];
  return (
    <>
      <section className="t-flex t-gap-4">
        <PlanCard
          price={0}
          type="Free"
          buttonText="Subscribe"
          features={freePlanFeatures}
          icon={<PaperPlaneSkyblue />}
          isActive={
            (!softwareStandardActivePlan?.group_subscription?.length &&
              !containsRadio) ||
            isFreePlanActive
          }
          description="Access to all the basic features you need to get your accounting started"
          isButtonDisabled
          hideUpgrade={hideUpgrade}
          containsRadio={containsRadio}
          isRadioDisabled={disableFreeplan || isRadioDisabled}
          onRadioChange={onRadioChange}
          radioValue={radioValue}
        />
        <PlanCard
          price={price}
          billingCycle={billingCycle}
          type={selectedPlan?.subscription_name || "Standard"}
          buttonText={buttonText}
          features={selectedPlan?.metadata?.comparison!}
          icon={<RocketPurpleAnimate />}
          description={selectedPlan?.metadata?.service_description || ""}
          planOptions={
            !softwareStandardActivePlan?.group_subscription?.length
              ? subscriptionPlans?.filter(
                  (item) => item?.subscription_type === BOOKS_PLUS_PLAN
                )!
              : undefined
          }
          onUpgrade={handleOnUpgrade}
          isActive={
            !!softwareStandardActivePlan?.group_subscription?.length || false
          }
          buttonType={buttonType}
          hideUpgrade={hideUpgrade}
          containsRadio={containsRadio}
          isRadioDisabled={isRadioDisabled}
          onRadioChange={onRadioChange}
          radioValue={radioValue}
          onPlanOptionSelect={
            containsRadio ? onPlanOptionSelect : setSelectedPlan
          }
          toggleValue={toggleValue}
        />
      </section>
    </>
  );
};
